import React, { useRef, useState } from 'react';
import SelectInput from '../FormFields/SelectInput';
import NumberInput from '../FormFields/NumberInput';
import { FaChevronDown } from 'react-icons/fa';
import onClickOutside from 'react-cool-onclickoutside';
import { Breakpoint } from 'react-socks';

function Filter(props) {
  const dropdownRef = useRef();
  const [disableClickOutside, setDisableClickOutside] = useState(true);
  onClickOutside(
    dropdownRef,
    () => props.handleChange("selectedCabinId", 0),
    {
      disabled: disableClickOutside
    }
  );

  const innerContentWrapperClass = "flex px-4 pb-2 lg:pb-1 lg:flex-col";
  const innerWrapperClass = "flex flex-col px-2 ";
  const labelClass = "text-xs text-black block mb-0 whitespace-no-wrap p-1";
  const defaultInputClass = "z-40 w-full ";
  const accordionHeader = "font-semibold px-4 py-1";
  const cardClass = "my-2 border-none rounded-none hover:bg-cruise_lightblue-secondary";
  const chevronDownClass = "ml-4";

  const durations = [
    { id: -1, label: "Any" },
    { id: '0', label: "1-2" },
    { id: '1', label: "3-5" },
    { id: '2', label: "6-9" },
    { id: '3', label: "10-14" },
    { id: '4', label: "15+" },
  ];

  function renderCabinSummary(cabin) {
    let persons = cabin.persons;
    let info = "";

    info = addInfo(persons.adults + persons.seniors, "adult", info);
    info = addInfo(persons.children + persons.juniorChildren + persons.infants, "child", info);
    if (cabin.cabintypeIds.length > 0 && props.searchFormArrays.cabinprimarytypes.length > 0) {
      let cabintypeId = cabin.cabintypeIds[cabin.cabintypeIds.length - 1];
      let cabintype = props.searchFormArrays.cabinprimarytypes.find(x => x.intId == cabintypeId).name;
      info += ", " + cabintype;
    }

    return info;
  }
  function addInfo(numberOfPerson, nameOfPerson, currentInfo) {
    if (numberOfPerson > 0) {
      if (currentInfo.length > 0) currentInfo += ", ";
      currentInfo += numberOfPerson + " " + nameOfPerson;
      if (numberOfPerson > 1) {
        if (nameOfPerson.endsWith("hild")) currentInfo += "ren";
        else currentInfo += "s";
      }
    }


    return currentInfo;
  }

  return (
    <div className={props.wrapperClass}>
      <div className="relative z-20 bg-cruise_lightblue-secondary "
        style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.16)' }}>
        <div className="px-4 py-1">
          <div className="border-b font-semibold">Your cabin</div>
        </div>
        <div className={innerContentWrapperClass}>
          {props.searchForm.cabins.map((cabin, index) =>
            <div key={cabin.id} className={innerWrapperClass}>
              <p className="font-semibold p-1">Cabin {index + 1}</p>
              <div>
                <div onClick={() => { props.handleChange("selectedCabinId", index + 1); setDisableClickOutside(false); }}
                  className="flex justify-between items-center whitespace-no-wrap cursor-pointer bg-white px-3 py-2 hover:bg-gray-200 rounded-lg">
                  <span>
                    {renderCabinSummary(cabin)}
                  </span>
                  <FaChevronDown className={chevronDownClass} />
                </div>
                {props.searchForm.selectedCabinId == index + 1 ?
                  <React.Fragment>
                    <div ref={dropdownRef}
                      className="absolute z-50 mt-2 p-2 bg-white shadow border border-blue-700 rounded-lg">
                      <div>
                        <NumberInput
                          wrapperClass={innerWrapperClass}
                          labelClass={labelClass}
                          numberInputClass={defaultInputClass}
                          id="adults"
                          name="adults"
                          label="Adults (18+)"
                          min={0}
                          value={cabin.persons.adults}
                          onChange={(name, value) => props.handleChange(name, value, index)}
                          typeId={1}
                        />
                        <NumberInput
                          wrapperClass={innerWrapperClass}
                          labelClass={labelClass}
                          numberInputClass={defaultInputClass}
                          id="seniors"
                          name="seniors"
                          label="Seniors"
                          min={0}
                          value={cabin.persons.seniors}
                          onChange={(name, value) => props.handleChange(name, value, index)}
                          typeId={1}
                        />
                      </div>
                      <div>
                        <NumberInput
                          wrapperClass={innerWrapperClass}
                          labelClass={labelClass}
                          numberInputClass={defaultInputClass}
                          id="children"
                          name="children"
                          label="Teens (12-18)"
                          min={0}
                          value={cabin.persons.children}
                          onChange={(name, value) => props.handleChange(name, value, index)}
                          typeId={1}
                        />
                        <NumberInput
                          wrapperClass={innerWrapperClass}
                          labelClass={labelClass}
                          numberInputClass={defaultInputClass}
                          id="juniorChildren"
                          name="juniorChildren"
                          label="Children (2-12)"
                          min={0}
                          value={cabin.persons.juniorChildren}
                          onChange={(name, value) => props.handleChange(name, value, index)}
                          typeId={1}
                        />
                        <NumberInput
                          wrapperClass={innerWrapperClass}
                          labelClass={labelClass}
                          numberInputClass={defaultInputClass}
                          id="infants"
                          name="infants"
                          label="Infants (0-2)"
                          min={0}
                          value={cabin.persons.infants}
                          onChange={(name, value) => props.handleChange(name, value, index)}
                          typeId={1}
                        />
                      </div>
                      <div className="py-2" >
                        <SelectInput
                          onOpen={() => setDisableClickOutside(true)}
                          onClose={() => setDisableClickOutside(false)}
                          wrapperClass=""
                          labelClass="hidden"
                          selectPickerClass={defaultInputClass}
                          id="cabintypeId"
                          name="cabintypeId"
                          label="Cabintype"
                          searchable={false}
                          onChange={(name, value) => props.handleChange(name, value, index)}
                          valueKey="intId"
                          firstOption="Select cabin-type"
                          options={props.searchFormArrays.cabinprimarytypes}
                          value={cabin.cabintypeIds[cabin.cabintypeIds.length - 1]}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                  : null
                }
              </div>
            </div>
          )}
          <NumberInput
            wrapperClass="flex flex-col px-2 pb-2 items-center"
            labelClass="w-32 text-black block mb-0 whitespace-no-wrap text-center p-1"
            numberInputClass={defaultInputClass}
            id="cabins"
            name="cabinId"
            label="Add/Remove cabins"
            min={1}
            max={3}
            value={props.searchForm.cabins.length}
            onChange={props.handleChange}
            typeId={1}
          />
        </div>
      </div>
      <div className="py-1" />
      <div className="border bg-white relative -mt-2 z-10">
        <div className={cardClass}>
          <div className={accordionHeader}>
            <div>Ports</div>
          </div>
          <div className={innerContentWrapperClass}>
            <SelectInput
              onOpen={() => props.dropdownOpen(true)}
              onClose={() => props.dropdownOpen(false)}
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              selectPickerClass={defaultInputClass}
              id="departureStoppoints"
              name="departureStoppointId"
              label="Departure ports"
              groupBy="country"
              onChange={props.handleChange}
              valueKey="intId"
              firstOption="departure port"
              options={props.searchFormArrays.stoppoints}
              value={props.searchForm.departureStoppointIds[props.searchForm.departureStoppointIds.length - 1]}
            />
            <SelectInput
              onOpen={() => props.dropdownOpen(true)}
              onClose={() => props.dropdownOpen(false)}
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              selectPickerClass={defaultInputClass}
              id="onRouteStoppoints"
              name="onRouteStoppointId"
              label="Visiting"
              groupBy="country"
              onChange={props.handleChange}
              valueKey="intId"
              firstOption="port on route"
              options={props.searchFormArrays.stoppoints}
              value={props.searchForm.onRouteStoppointIds[props.searchForm.onRouteStoppointIds.length - 1]}
            />
            <SelectInput
              onOpen={() => props.dropdownOpen(true)}
              onClose={() => props.dropdownOpen(false)}
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              selectPickerClass={defaultInputClass}
              id="arrivalStoppoints"
              name="arrivalStoppointId"
              label="Arrival ports"
              groupBy="country"
              onChange={props.handleChange}
              valueKey="intId"
              firstOption="arrival port"
              options={props.searchFormArrays.stoppoints}
              value={props.searchForm.arrivalStoppointIds[props.searchForm.arrivalStoppointIds.length - 1]}
            />
            <div className="flex items-center pl-2 lg:pl-8 pt-2">
              <input type="checkbox" id="roundtrip" name="roundtrip"
                checked={props.searchForm.roundtrip}
                onChange={(e) => props.handleChange(e.target.name, e.target.checked)}
              />
              <label htmlFor="roundtrip" className="cursor-pointer px-4">Roundtrip</label>
              {/*
              <Checkbox
                checkboxClass="w-full whitespace-no-wrap"
                name="roundtrip"
                checkedText="Roundtrip"
                uncheckedText="Not only Roundtrip"
                value={props.searchForm.roundtrip}
                onChange={props.handleChange}
              />
              */}
            </div>
          </div>
        </div>
        <div className={cardClass}>
          <div className={accordionHeader}>
            <div className="border-t pt-1">Duration</div>
          </div>
          <div className={innerContentWrapperClass}>
            <SelectInput
              onOpen={() => props.dropdownOpen(true)}
              onClose={() => props.dropdownOpen(false)}
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              selectPickerClass={defaultInputClass}
              id="durationMinMax"
              name="durationMinMax"
              label="Quick select"
              searchable={false}
              firstOption="duration"
              labelKey="label"
              options={durations}
              onChange={props.handleChange}
            />
            <NumberInput
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              numberInputClass={defaultInputClass}
              id="durationMin"
              name="durationMin"
              label="Min duration"
              value={props.searchForm.durationMin}
              onChange={props.handleChange}
            />
            <NumberInput
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              numberInputClass={defaultInputClass}
              id="durationMax"
              name="durationMax"
              label="Max duration"
              value={props.searchForm.durationMax}
              onChange={props.handleChange}
            />
          </div>
        </div>
        <div className="hover:bg-cruise_lightblue-secondary">
          <div className={innerContentWrapperClass + " border-t"}>
            <SelectInput
              onOpen={() => props.dropdownOpen(true)}
              onClose={() => props.dropdownOpen(false)}
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              selectPickerClass={defaultInputClass}
              id="cruiselineId"
              name="cruiselineId"
              label="Operators"
              onChange={props.handleChange}
              valueKey="intId"
              firstOption="ANY"
              options={props.searchFormArrays.cruiselines}
              value={props.searchForm.cruiselineIds[props.searchForm.cruiselineIds.length - 1]}
            />
            <SelectInput
              onOpen={() => props.dropdownOpen(true)}
              onClose={() => props.dropdownOpen(false)}
              wrapperClass={innerWrapperClass}
              labelClass={labelClass}
              selectPickerClass={defaultInputClass}
              id="shipId"
              name="shipId"
              label="Ship"
              onChange={props.handleChange}
              valueKey="intId"
              firstOption="Select Ship"
              options={props.searchFormArrays.ships}
              value={props.searchForm.shipIds[props.searchForm.shipIds.length - 1]}
            />
            <Breakpoint md down >
              <NumberInput
                wrapperClass={innerWrapperClass}
                labelClass={labelClass}
                numberInputClass="w-full bg-cruise_darkblue text-white cursor-pointer text-center"
                id="priceMax"
                name="priceMax"
                label="Max price"
                step={1000}
                value={props.searchForm.priceMax || 0}
                onChange={props.handleChange}
              />
            </Breakpoint>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filter;